/*
 * HardWay Performance — Fee Lock + Consent
 * =========================================
 * Magical Fees handles adding/pricing the fee line item.
 * This script does three things:
 *   1. Fixes fee display — undoes Magical Fees JS strikethrough/$0 overwrite
 *   2. Locks the fee line item (hides remove button + qty controls)
 *   3. Shows a consent popup on first cart open / before checkout
 */

(function () {
  'use strict';

  var FEE_PRODUCT_TYPE    = 'Fee Placeholder';
  var CONSENT_STORAGE_KEY = 'hw_fee_consent_v1';
  var CONSENT_TITLE       = 'Order Processing Fee';
  var CONSENT_MESSAGE     = 'A 3% processing fee is applied to all orders to cover credit card processing costs. This fee is non-refundable and will be added to your order total.';
  var CONSENT_BUTTON      = 'I Understand — Continue';

  // ── CONSENT ──────────────────────────────────────────────────────────────
  // In-memory flag is authoritative so a blocked/throwing sessionStorage
  // (private mode, storage partitioning, etc.) can never leave the checkout
  // gate stuck waiting on a flag that can never become true.
  var consentGivenInMemory = false;

  function hasConsented() {
    if (consentGivenInMemory) return true;
    try { return sessionStorage.getItem(CONSENT_STORAGE_KEY) === '1'; } catch (e) { return false; }
  }

  function setConsented() {
    consentGivenInMemory = true;
    try { sessionStorage.setItem(CONSENT_STORAGE_KEY, '1'); } catch (e) {}
  }

  function buildConsentPopup() {
    if (document.getElementById('hw-fee-consent-overlay')) return;

    var style = document.createElement('style');
    style.textContent = [
      '#hw-fee-consent-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.72);display:flex;align-items:center;justify-content:center;padding:20px;animation:hwFadeIn 0.2s ease}',
      '@keyframes hwFadeIn{from{opacity:0}to{opacity:1}}',
      '#hw-fee-consent-modal{background:#111;border:1px solid #2a2a2a;border-top:3px solid #E8272A;border-radius:4px;padding:36px 32px 32px;max-width:420px;width:100%;text-align:center;font-family:"Barlow Condensed","Barlow",sans-serif}',
      '#hw-fee-consent-icon{font-size:36px;font-weight:700;color:#E8272A;margin-bottom:12px;font-family:"Bebas Neue","Barlow Condensed",sans-serif;letter-spacing:2px}',
      '#hw-fee-consent-title{font-family:"Bebas Neue","Barlow Condensed",sans-serif;font-size:22px;letter-spacing:2px;color:#fff;margin:0 0 14px;text-transform:uppercase}',
      '#hw-fee-consent-msg{font-size:14px;color:#aaa;line-height:1.6;margin:0 0 24px}',
      '#hw-fee-consent-btn{background:#E8272A;color:#fff;border:none;border-radius:3px;font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:14px 28px;cursor:pointer;width:100%;transition:background 0.15s}',
      '#hw-fee-consent-btn:hover{background:#B01F21}',
    ].join('\n');
    document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.id = 'hw-fee-consent-overlay';
    overlay.innerHTML =
      '<div id="hw-fee-consent-modal">' +
      '<div id="hw-fee-consent-icon">%</div>' +
      '<h3 id="hw-fee-consent-title">' + CONSENT_TITLE + '</h3>' +
      '<p id="hw-fee-consent-msg">' + CONSENT_MESSAGE + '</p>' +
      '<button id="hw-fee-consent-btn">' + CONSENT_BUTTON + '</button>' +
      '</div>';
    document.body.appendChild(overlay);

    document.getElementById('hw-fee-consent-btn').addEventListener('click', function () {
      setConsented();
      overlay.style.animation = 'hwFadeIn 0.15s ease reverse';
      setTimeout(function () { overlay.remove(); }, 150);
    });
  }

  function showConsentIfNeeded() {
    if (!hasConsented()) buildConsentPopup();
  }

  // ── FORMAT MONEY ──────────────────────────────────────────────────────────

  function formatMoney(cents) {
    var dollars = Math.floor(cents / 100);
    var pennies = String(cents % 100).padStart(2, '0');
    return '$' + dollars + '<sup>' + pennies + '</sup>';
  }

  // ── FIX + LOCK FEE LINE ITEM ──────────────────────────────────────────────

  function fixAndLockFeeItems() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (item) {
          if (item.product_type !== FEE_PRODUCT_TYPE) return;

          var feeEl = document.querySelector('.cart__item[data-key="' + item.key + '"]');
          if (!feeEl) return;

          // Already locked — stop here so we don't mutate the DOM again.
          // Without this guard every DOM change we make triggers the MutationObserver,
          // which schedules another run, which makes more changes — an infinite loop.
          // That loop floods window.fetch (patched by Magical Fees) and blocks checkout.
          if (feeEl.dataset.hwFeeLocked === '1') return;

          var feeCents = item.line_price; // Magical Fees sets this correctly server-side

          // ── Fix price display ──
          var priceCol = feeEl.querySelector('.cart__item-price-col');
          if (priceCol && feeCents > 0) {
            // Wipe the entire price column and replace with clean correct price
            // This removes any strikethrough, $0, or other Magical Fees DOM injections
            priceCol.innerHTML =
              '<span class="cart__price">' +
                '<span aria-hidden="true">' + formatMoney(feeCents) + '</span>' +
                '<span class="visually-hidden">$' + (feeCents / 100).toFixed(2) + '</span>' +
              '</span>';
          }

          // ── Lock the item ──
          feeEl.dataset.hwFeeLocked = '1';

          var removeEl = feeEl.querySelector('.cart__remove');
          if (removeEl) removeEl.style.display = 'none';

          var qtyEl = feeEl.querySelector('.js-qty__wrapper');
          if (qtyEl) qtyEl.style.visibility = 'hidden';

          if (!feeEl.querySelector('.hw-fee-required-label')) {
            var label = document.createElement('div');
            label.className = 'hw-fee-required-label';
            label.style.cssText = 'font-size:11px;color:#888;margin-top:4px;letter-spacing:0.5px;text-transform:uppercase;';
            label.textContent = 'Required';
            var sub = feeEl.querySelector('.cart__item-sub > div');
            if (sub) sub.appendChild(label);
          }
        });
      });
  }

  // ── CHECKOUT GATE ────────────────────────────────────────────────────────

  function patchCartFormsForCheckout() {
    // Magical Fees intercepts the cart form's submit event, does its fee sync,
    // then calls native form.submit(). Native form.submit() does not include the
    // submit button's name/value, so the "checkout" field is lost and Shopify
    // returns 204 No Content instead of redirecting to checkout.
    //
    // Fix: on the first submit (capture phase, before Magical Fees runs), inject
    // a hidden name="checkout" field. It survives into Magical Fees' form.submit()
    // so Shopify always sees the checkout signal and creates the checkout session.
    document.querySelectorAll('form[data-location]').forEach(function (form) {
      form.addEventListener('submit', function () {
        if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
          var h = document.createElement('input');
          h.type  = 'hidden';
          h.name  = 'checkout';
          h.value = '';
          form.appendChild(h);
        }
      }, true);
    });
  }

  function interceptCheckout() {
    // Consent gate only. When consent is already given the click propagates
    // naturally so WCP (dealer draft-order pricing) can intercept it first.
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest(
        "input[name='checkout'], button[name='checkout'], " +
        "[href$='/checkout'], .cart__checkout, " +
        ".wcp_checkout_btn"
      );
      if (!btn || hasConsented()) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      buildConsentPopup();

      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (hasConsented()) {
          clearInterval(interval);
          btn.click();
        } else if (attempts > 150) {
          clearInterval(interval);
        }
      }, 200);
    }, true);
  }

  // ── EVENT WIRING ─────────────────────────────────────────────────────────

  function init() {
    // Run immediately and after delays to catch Magical Fees JS running late
    fixAndLockFeeItems();
    setTimeout(fixAndLockFeeItems, 600);
    setTimeout(fixAndLockFeeItems, 1500);

    // Cart drawer open
    document.addEventListener('CartDrawer:open', function () {
      showConsentIfNeeded();
      setTimeout(fixAndLockFeeItems, 400);
      setTimeout(fixAndLockFeeItems, 1000);
    });

    // After any cart update or item add
    document.addEventListener('cart:updated', function () {
      setTimeout(fixAndLockFeeItems, 400);
      setTimeout(fixAndLockFeeItems, 1200);
    });
    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(fixAndLockFeeItems, 600);
      setTimeout(fixAndLockFeeItems, 1500);
    });

    // Watch for DOM changes in cart containers — catches Magical Fees rewrites.
    // The flag prevents stacking multiple pending fixAndLockFeeItems calls when
    // many mutations fire in rapid succession (e.g. cart rebuild).
    var fixScheduled = false;
    var observer = new MutationObserver(function () {
      if (!fixScheduled) {
        fixScheduled = true;
        setTimeout(function () { fixScheduled = false; fixAndLockFeeItems(); }, 200);
      }
    });
    var cartContainers = document.querySelectorAll('[data-products], .cart__items, #CartDrawer, #CartPageForm');
    cartContainers.forEach(function (c) {
      observer.observe(c, { childList: true, subtree: true });
    });

    patchCartFormsForCheckout();
    interceptCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();